import type {
    InputMaybe,
    PriceListUerRowBaseFilterInput,
    PriceListUerSectionData,
    StringOperationFilterInputTypeExFilterInput,
} from 'gql/graphql';
import { RatioTypeEnum } from 'gql/graphql';

import { useMemo } from 'react';

export interface IUseUerRatioSelectorVariables {
    searchValue: string;
    currentFilters: Record<string, string[]> | null;
    contractId: number;
    ratioType: RatioTypeEnum;
    selectedGroup?: PriceListUerSectionData | null;
}

export const usePriceListForUerTableVariables = ({
    searchValue,
    currentFilters,
    contractId,
    ratioType,
    selectedGroup,
}: IUseUerRatioSelectorVariables) =>
    useMemo(() => {
        const search: InputMaybe<StringOperationFilterInputTypeExFilterInput> | undefined = searchValue
            ? { containsi: searchValue }
            : undefined;
        const groupNameValues = currentFilters?.groupName;
        const groupNameFilter: InputMaybe<StringOperationFilterInputTypeExFilterInput> | undefined =
            groupNameValues?.length ? { in: groupNameValues } : undefined;

        const codeFilterValues = currentFilters?.code;
        const codeFilter: InputMaybe<StringOperationFilterInputTypeExFilterInput> | undefined = codeFilterValues?.length
            ? { in: codeFilterValues }
            : undefined;

        const nameFilterValues = currentFilters?.name;
        const nameFilter: InputMaybe<StringOperationFilterInputTypeExFilterInput> | undefined = nameFilterValues?.length
            ? { in: nameFilterValues }
            : undefined;

        const notSectionIsArtificial =
            ratioType === RatioTypeEnum.ConstraintCoef ? { sectionIsArtificial: { neq: true } } : undefined;

        const withActiveFilter = searchValue || codeFilter || nameFilter || groupNameFilter || selectedGroup;

        const where: PriceListUerRowBaseFilterInput | undefined = withActiveFilter
            ? {
                  and: [
                      ...(notSectionIsArtificial ? [notSectionIsArtificial] : []),
                      ...(selectedGroup
                          ? [
                                {
                                    sectionId: {
                                        eq: selectedGroup?.id,
                                    },
                                },
                            ]
                          : []),
                      ...(searchValue ? [{ or: [{ code: search }, { name: search }, { groupName: search }] }] : []),
                      ...(codeFilter ? [{ code: codeFilter }] : []),
                      ...(nameFilter ? [{ name: nameFilter }] : []),
                      ...(groupNameFilter ? [{ groupName: groupNameFilter }] : []),
                  ],
              }
            : notSectionIsArtificial;

        return {
            contractId,
            where,
        };
    }, [
        contractId,
        currentFilters?.code,
        currentFilters?.groupName,
        currentFilters?.name,
        ratioType,
        searchValue,
        selectedGroup,
    ]);
